import {useEffect, useRef} from 'react';
import {StepId, StepState} from '../../../types/checkoutApp.types';
import {useControllerProps} from '../Widget/ControllerContext';

type UseReportStageExpandedProps = {
  stepState: StepState;
  stepId: StepId;
};

export const useReportStageExpanded = ({stepState, stepId}: UseReportStageExpandedProps) => {
  const {
    stepsManagerStore: {sendStageExpandedBIEvent},
    checkoutStore: {cart, cartSummary},
  } = useControllerProps();
  const prevStateRef = useRef<StepState | undefined>(undefined);

  useEffect(
    () => {
      if (stepState === StepState.OPEN && prevStateRef.current !== StepState.OPEN) {
        sendStageExpandedBIEvent({cart, cartSummary, stepId});
      }
      prevStateRef.current = stepState;
    },
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
    [stepId, stepState, cart.id]
  );
};
